import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import {
  isRequired,
} from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import FormFooter from '../../../common/forms/FormFooter';
import Loader from '../../../common/Loader';
import Select from '../../../common/forms/select/Select';
import { enumToSelectOptions } from '../../../../utils/enum';
import { TRANSACTION_CODE } from '../../../../config/constants';


export const PaymentMethodForm = ({ handleSubmit, loading }) =>
  loading ? (
    <Loader />
  ) : (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Nombre" required>
          <Field
            name="name"
            component={TextInput}
            type="text"
            placeholder="Nombre"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Descripción">
          <Field
            name="description"
            component={TextInput}
            type="textarea"
            placeholder="Descripción"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Código de Transacción" required={[[isRequired]]}>
          <Field
            name="transactionCode"
            id="transactionCode"
            component={Select}
            options={enumToSelectOptions(TRANSACTION_CODE)}
            showToolTip
            placeholder="Select"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormFooter />
    </Form>
  );

const mapStateToProps = ({ AccountingUnit }) => ({
  loading: !AccountingUnit.PaymentMethod.getIn(['current', 'activity']).isEmpty(),
});

PaymentMethodForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

PaymentMethodForm.defaultProps = {
  loading: false,
};

const formComponent = reduxForm({
  form: 'PaymentMethodForm',
})(PaymentMethodForm);

export default connect(mapStateToProps)(formComponent);
